<template>
  <div class="subPage">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item>通知公告</el-breadcrumb-item>
    </bread-crumb>
    <div class="carouselList">
      <div class="carouselItem" v-for="(item, index) in dataList" :key="index" @click="toDetail(item.UnitGuid)">
        <div>
          <img src="~@/assets/img/yuandian_icon.png" />
          <span>{{ item.Title }}</span>
        </div>
        <div>{{ item.AddDate }}</div>
      </div>
    </div>
    <!-- 分页 -->
    <pagination :pagedata="pageData" @getList="getList"></pagination>
  </div>
</template>

<script>
import { getInforList } from "@/api/index.js";
export default {
  name: "SubPage",
  data() {
    return {
      pageData: {
        currentPage: 1,
        pageSize: 10, //一页放几行数据
        total: 0,
      },
      dataList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 公司动态列表
    getList() {
      let data = {
        ClassCode: "800001",
        PageIndex: this.pageData.currentPage,
        PageSize: this.pageData.pageSize,
        TenantID: this.$store.state.tenantid,
        IsSlider: 0,
      };
      getInforList(data).then((res) => {
        if (res) {
          this.dataList = res.message;
          this.pageData.total = res.RecordTotalNum;
        }
      });
    },
    toDetail(unitguid) {
      this.$router.push({
        name: "tzDetailInfo",
        query: {
          unitguid: unitguid,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.subPage {
  min-height: calc(100vh - 406px);
  padding-bottom: 20px;
  .carouselList {
    width: 1200px;
    margin: 0 auto;
    padding-top: 10px;
    .carouselItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      height: 48px;
      border-bottom: 1px solid $border-color-EBEBEB;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
      div {
        &:first-child {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          img {
            width: 4px;
            margin-right: 8px;
          }
        }
        &:last-child {
          color: $color-9;
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
